import { API_BASE_URL } from '../../config/api';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../component/SEO';
import axios from 'axios';
import './News.css';

const News = () => {
  const { t, i18n } = useTranslation();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/api/news/`, {
          headers: {
            'Accept-Language': i18n.language
          }
        });
        setNews(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching news:', err);
        setError(t('news.fetchError'));
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [i18n.language, t]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat(i18n.language, { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    }).format(date);
  };

  return (
    <div className="test_block">
      <SEO
        title={`${t('news.title')} | ${t('seo.defaultTitle')}`}
        description={`${t('news.latestNews')} - ${t('seo.defaultDescription')}`}
      />
      
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <h3 className="main-content__main-products desktop-title">{t('news.title')}</h3>
          </div>
        </div>
        
        {loading && (
          <div className="text-center my-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">{t('common.loading')}</span>
            </div>
          </div>
        )}
        
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        
        {!loading && !error && news.length === 0 && (
          <div className="alert alert-info" role="alert">
            {t('news.noNews')}
          </div>
        )}
        
        {!loading && !error && news.length > 0 && (
          <div className="row news-list">
            {news.map((item) => (
              <div key={item.id} className="col-lg-4 col-md-6 col-sm-12 col-xs-12 news-item">
                <div className="news-card">
                  <div className="news-image">
                    <img src={item.image} alt={item.title} />
                  </div>
                  <div className="news-content">
                    <div className="news-date">{formatDate(item.date)}</div>
                    <h3 className="news-card-title">{item.title}</h3>
                    <div className="news-summary" dangerouslySetInnerHTML={{ __html: item.summary }} />
                    <Link to={`/news/${item.id}`} className="news-read-more">
                      {t('news.readMore')}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default News;
